// Lives here (zero-dependency) because importing it from @/shared-project drags react-player into a Server Component and crashes SSR.
export const URL_QUESTION_TEXT =
  'You are about to be redirected to a new page, click here if it does not load automatically.';

export function isUrlQuestionText(text: string | null | undefined): boolean {
  return text === URL_QUESTION_TEXT;
}

export const CONTENT_URL_MEDIA_KINDS = {
  Image: 'image',
  Video: 'video',
} as const;

export type ContentUrlMediaKind =
  (typeof CONTENT_URL_MEDIA_KINDS)[keyof typeof CONTENT_URL_MEDIA_KINDS];

const VIDEO_EXTENSIONS: ReadonlySet<string> = new Set([
  'avi',
  'm3u8',
  'm4v',
  'mkv',
  'mov',
  'mp4',
  'mpeg',
  'mpg',
  'ogv',
  'webm',
]);

const IMAGE_EXTENSIONS: ReadonlySet<string> = new Set([
  'avif',
  'gif',
  'jpeg',
  'jpg',
  'png',
  'svg',
  'webp',
]);

function resolveFileExtension(contentUrl: string): string {
  const withoutQuery = contentUrl.split(/[?#]/)[0] ?? '';
  const fileName = withoutQuery.split('/').pop() ?? '';
  const dotIndex = fileName.lastIndexOf('.');

  if (dotIndex <= 0 || dotIndex === fileName.length - 1) {
    return '';
  }

  return fileName.slice(dotIndex + 1).toLowerCase();
}

export function resolveContentUrlMediaKind(
  contentUrl: string | null | undefined
): ContentUrlMediaKind | null {
  if (contentUrl === null || contentUrl === undefined) {
    return null;
  }

  const extension = resolveFileExtension(contentUrl.trim());

  if (VIDEO_EXTENSIONS.has(extension)) {
    return CONTENT_URL_MEDIA_KINDS.Video;
  }

  if (IMAGE_EXTENSIONS.has(extension)) {
    return CONTENT_URL_MEDIA_KINDS.Image;
  }

  return null;
}

export function isPageUrl(contentUrl: string | null | undefined): boolean {
  return (
    contentUrl !== null &&
    contentUrl !== undefined &&
    contentUrl.trim() !== '' &&
    resolveContentUrlMediaKind(contentUrl) === null
  );
}
